import { HTMLAttributes, PropsWithChildren, useEffect } from 'react';

import { useClassHelper } from '../../../../../../hooks/useClassHelper';
import { Dropdown } from '../../../../../Dropdown/Dropdown';
import { componentName } from '../../constants';

interface Props extends PropsWithChildren, HTMLAttributes<HTMLHeadingElement> {
  fontFamily: string;
}

export const Title = ({ children, className, fontFamily, ...props }: Props) => {
  const c = useClassHelper(componentName);

  return (
    <Dropdown.GoogleFont.Viewer
      fontFamily={fontFamily}
      useAsVariableWrapper={false}
    >
      <h2 className={c('__title', className)} {...props}>
        {children}
      </h2>
    </Dropdown.GoogleFont.Viewer>
  );
};
